<template>
  <div>
    <!-- Content -->
    <div
      class="w-full h-full flex justify-center pt-0 p-4 mt-10 tablet-v:mt-[56px] desktop:mt-[126px]"
    >
      <div class="w-full max-w-[440px]">
        <!-- Header -->
        <div class="flex items-center justify-between mb-[50px]">
          <div
            class="font-primary font-medium text-[26px] leading-[20px] text-gray-800"
          >
            Forgot your password?
          </div>
        </div>

        <!-- Form -->
        <form class="flex flex-col" @submit.prevent="handleSendResetLink">
          <div
            class="font-primary text-[14px] leading-[20px] text-gray-800 mb-6"
          >
            Enter the email address associated with your account, and we'll
            email you a link to reset your password.
          </div>
          <div class="mb-5">
            <Input
              v-model="email"
              size="xl"
              label="Email"
              type="email"
              :disabled="loading"
              :error="errorMsg"
            />
          </div>
          <div class="w-full flex justify-end">
            <Button
              class="w-full! tablet-h:w-auto!"
              variant="primary"
              size="lg"
              :disabled="disableButton"
              :loading="loading"
              @click="handleSendResetLink"
            >
              Send reset link
            </Button>
          </div>
          <button
            type="submit"
            class="hidden"
            aria-hidden="true"
            tabindex="-1"
            :disabled="loading || disableButton"
          />
        </form>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { Button, Input } from '@dacr/library'
import { useForgotPasswordMutation } from '@/shared/graphql/legacy/generated'
import { ToastType, useToastStore } from '@/shared/stores/toast'
import { EMAIL_REGEX } from '@/shared/utils/string'

const { loading, mutate: forgotPassword } = useForgotPasswordMutation()

const toastStore = useToastStore()

const email = ref('')
const errorMsg = ref('')

const disableButton = computed(() => !email.value.length)

const handleSendResetLink = async () => {
  try {
    if (email.value.trim() && !EMAIL_REGEX.test(email.value.trim())) {
      errorMsg.value = 'Please enter a valid email.'
      return
    }

    await forgotPassword({
      email: email.value,
    })

    toastStore.showToast({
      type: ToastType.Success,
      content: `If a Dacr account exists for ${email.value}, an email will be sent with further instructions.`,
      timeout: 10_000,
    })

    email.value = ''
  } catch (error) {
    if (error instanceof Error) {
      toastStore.showToast({
        type: ToastType.Error,
        content: 'Something went wrong - please try again later',
        error,
      })
    }
  }
}
</script>
